import React from "react";
import { Link } from "react-router-dom";
import { getLinkCellStyle } from "../../utils/pluginHelpers.jsx";

export default function GridClientCardCell(props) {
    const value = props.dataItem[props.field];
    const href = `/card/client/${value}`;
    return <td {...getLinkCellStyle(props)}>
        <Link to={href} title={window.captions.ClientCard}>
            <i className={`dm-i dm-i-chevron_right`} />
        </Link>
    </td>;
}